const slides = [
  {
    image: "./assets/bmt/medical_professionals.png",
  },
  {
    image: "./assets/bmt/medical_facility.jpg",
  },
  {
    image: "./assets/bmt/doctor.jpg",
  },
  {
    image: "./assets/bmt/medical_professionals.png",
  },
  {
    image: "./assets/bmt/operating_room.jpg",
  },
  {
    image: "./assets/bmt/happy_users.jpg",
  },
];

export default slides;
